import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Home14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6.46973 0.46967C6.76262 0.176777 7.23749 0.176777 7.53039 0.46967L13.5304 6.46967L12.4697 7.53033L12.29 7.35064V12C12.29 12.4142 11.9543 12.75 11.54 12.75H2.54004C2.12583 12.75 1.79004 12.4142 1.79004 12V7.27068L1.53039 7.53033L0.469727 6.46967L6.46973 0.46967ZM7.00006 2.06066L10.79 5.85064V11.25H9.25V9.5C9.25 8.25736 8.24264 7.25 7 7.25C5.75736 7.25 4.75 8.25736 4.75 9.5V11.25H3.29004V5.77068L7.00006 2.06066ZM6.25 11.25H7.75V9.5C7.75 9.08579 7.41421 8.75 7 8.75C6.58579 8.75 6.25 9.08579 6.25 9.5V11.25Z'
      fill='currentColor'
    />
  </Svg>
);

Home14.displayName = 'Home14';
export default Home14;
